import {getNotification} from '@/helper'
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'

const notificationStore = {
  state: {
    notifications: [],
    totalNotificationsCountIncludeAcknowledged: null
  },
  getters: {
    notificationCount: state => {
      //let count = state.notifications.length
      let count = state.totalNotificationsCountIncludeAcknowledged
      return count
    },
    recentNotificationsCount: (state, getters) => {
      let count = getters.recentNotifications.length
      return count
    },
    recentNotifications: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged)
      })
    },
    lowSeverityNotificationsCount: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged&&x.severity.toLowerCase()==="low")
      }).length
    },
    mediumSeverityNotificationsCount: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged&&x.severity.toLowerCase()==="medium")
      }).length
    },

      criticalSeverityNotificationsCount: state => {
        return _.filter(state.notifications, function(x) {
          return (!x.acknowledged&&x.severity.toLowerCase()==="critical")
        }).length
      },
      highSeverityNotificationsCount: state => {
        return _.filter(state.notifications, function(x) {
          return (!x.acknowledged&&x.severity.toLowerCase()==="high")
        }).length
      },
    importantNotificationsCount: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged&&!(x.topic==="anomaly"||x.title.toLowerCase().startsWith("anomaly"))&&(x.severity.toLowerCase()==="critical"||x.severity.toLowerCase()==="high"||x.severity.toLowerCase()==="medium"))
      }).length
    }
  },
  actions: {
    async refreshNotification (context, payload) {
      // payload is a dict with facility_name and ignore_acknowledged
      if (process.env.VUE_APP_DEMO_SITE=='yes'){


      let result = [
          {
            icon: 'fa-bell',
            alertType: "FDD",
            title: 'Condenser Cleaning Required in Chiller 1',
            equip: 'Chiller 1',
            startDate: '2018-04-13',
            endDate: '2018-05-29',
            to: {path: '/sensors',
              query:{
                onOnly: true,
                variableX: 'Cond_Approach',
                variableY: 'Cond_Approach',
                rangeStart: '2018-01-01',
                rangeEnd: '2018-06-30',
                equipment: 'Chiller 1'
              }},
            description: "Condenser Approach High in Chiller 1",
            severity: "High",
            recommendedActions: [
              'Clean Condenser Tubes',
              'Check Condenser Water Pumps',
            ].join('\n')
          },
          {
            icon: 'fa-bell',
            alertType: "FDD",
            title: 'Check Cond. Refrigerant Temperature in Chiller 1',
            equip: 'Chiller 1',
            startDate: '2018-07-28',
            endDate: '2019-09-01',
            to: {path: '/sensors',
              query:{
                onOnly: true,
                variableX: 'Cond_Approach',
                variableY: 'Cond_Approach',
                rangeStart: '2018-07-01',
                rangeEnd: '2018-09-30',
                equipment: 'Chiller 1'
              }},
            severity: "Medium",
            description: "Condenser Approach Negative in Chiller 1",
            recommendedActions: [
              'Check Refrigerant Temperature',
              'Cond. Refrigerant Temperature sensor fault'
            ].join('\n')
          },

          {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Flow Rate Low in Chiller 2',
            equip: 'Chiller 2',
            startDate: '2018-09-12',
            endDate:'2018-09-14',
            to: {path: '/sensors',
            query:{
                onOnly: true,
                variableX: 'Flow_Rate',
                variableY: 'Flow_Rate',
                rangeStart: '2018-09-12',
                rangeEnd: '2018-09-14',
                equipment: 'Chiller 2'
              }
              },
            description: 'Flow Rate Too Low in Chiller 2.  Anomalies Detected in Chiller 2.',
            recommendedActions: [
              "Offline Chiller as precaution",
              "Check Flow Rate Sensor",
              "Check Pumps",
              "Make sure refrigerant is not too cold after Evaporator"
            ].join('\n'),
            severity: "Medium"
          },
          // New Faults
          {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Turn off chiller isolation valve',
            equip: 'Chiller 1',
            startDate: '2017-12-17',
            endDate: '2017-12-28',
            to: {path: '/sensors',
              query:{
                onOnly: false,
                variableX: 'Flow_Rate',
                variableY: 'Flow_Rate',
                rangeStart: '2017-12-13',
                rangeEnd: '2017-12-19',
                equipment: 'Chiller 1'
              }},
            description: 'Flow exists in chiller even though the chiller compressor is not running ',
            recommendedActions: [
              "Check chiller isolation valve status",
              "Check AO from chiller PLC to isolation valve",
              "Modify control logic on BMS"
            ].join('\n'),
            severity: "Medium"
          },
          {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Calibrate evaporator refrigerant temperature sensor ',
            equip: 'Chiller 2',
            startDate: '2018-01-01',
            endDate: '2018-09-18',
            to: {path: '/sensors',
              query:{
                onOnly: false,
                variableX: 'Evap Approach',
                variableY: 'on',
                rangeStart: '2017-05-16',
                rangeEnd: '2017-05-22',
                equipment: 'Chiller 2'
              }},
            description: 'Evaporator approach is negative in chiller when is operational',
            recommendedActions: [
              "Check, calibrate/replace evap ref sensor",
              "Check, calibrate/replace chilled water supply temperature sensor"
            ].join('\n'),
            severity: "Medium"
          },

          {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Reduce chilled water flow in chiller ',
            equip: 'Chiller 1',
            startDate: '2017-02-12',
            endDate: '2017-02-13',
            to: {path: '/sensors',
              query:{
                onOnly: false,
                variableX: 'CHW_Temp_Diff',
                variableY: 'Flow_Rate',
                rangeStart: '2017-02-09',
                rangeEnd: '2017-02-15',
                equipment: 'Chiller 1'
              }},
            description: 'Chiller delta T too low (< 2.5 Deg C) and flow too high (> 90 L/s)',
            recommendedActions: [
              "Check and modify primary chilled water pumps staging to reduce water flow"
            ].join('\n'),
            severity: "High"
          },


           {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Calibrate evaporator refrigerant temperature sensor ',
            equip: 'Chiller 4',
            startDate: '2017-11-01',
             endDate: '2018-11-01',
            to: {path: '/sensors',
              query:{
                onOnly: false,
                variableX: 'Evap Approach',
                variableY: 'on',
                rangeStart: '2017-02-21',
                rangeEnd: '2017-02-27',
                equipment: 'Chiller 4'
              }},
            description: 'Evaporator approach is negative in chiller when is operational',
            recommendedActions: [
              "Check, calibrate/replace evap ref sensor",
              "Check, calibrate/replace chilled water supply temperature sensor"
            ].join('\n'),
            severity: "Medium"
          },


          {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Reduce condensing water flow in chiller',
            equip: 'Chiller 4',
            startDate: '2016-11-24',
            endDate: '2016-11-25',
            to: {path: '/sensors',
              query:{
                onOnly: false,
                variableX: 'Cond_Sat_Refrig_Temp',
                variableY: 'SWS_Temp',
                rangeStart: '2016-11-21',
                rangeEnd: '2016-11-27',
                equipment: 'Chiller 4'
              }},
            description: 'Evaporator approach is negative in chiller when is operational',
            recommendedActions: [
              "Check, calibrate/replace evap ref sensor",
              "Check, calibrate/replace chilled water supply temperature sensor"
            ].join('\n'),
            severity: "Medium"
          },

          {
            icon: 'fa-bell',
            alertType: "Predictive",
            title: 'Check refrigerant charge/quality and evaporator tubes of chiller',
            equip: 'Chiller 1',
            startDate: '2017-12-29',
            endDate: '2017-12-30',
            to: {path: '/sensors',
              query:{
                onOnly: false,
                variableX: 'CHWS_Temp',
                variableY: 'Refrigerant_Temp',
                rangeStart: '2017-12-26',
                rangeEnd: '2018-01-01',
                equipment: 'Chiller 1'
              }},
            description: 'Refrigerant is over cooled and evaporator approach is >1.8 Deg C',
            recommendedActions: [
              "Clean evaporator tubes",
              "Check refrigerant pressure & purity"
            ].join('\n'),
            severity: "High"
          },
        ]
      context.commit('updateNotification', result)
    } else {
        let maxDate=moment()
        if(context.rootState.pointsListStore.pointsList.data_max_date){
           maxDate=moment(context.rootState.pointsListStore.pointsList.data_max_date)
        }
      // get update from DB
       let notifications =  await getNotification({
          'facility_name': payload['facility_name'],
          'ignore_acknowledged': payload['ignore_acknowledged'],
         'date_range': [moment(maxDate).subtract(90, "days").format('YYYY-MM-DD'),moment(maxDate).format('YYYY-MM-DD')+" 23:59:59"]
        })
        let output = []

        for (let i in notifications['result']) {
          output.push({
            icon: 'fa-bell',
            alertType: notifications['result'][i]['model'],
            title: notifications['result'][i]['title'],
            equip: notifications['result'][i]['equipment_name'],
            equipType: notifications['result'][i]['equipment_type'],
            floor: notifications['result'][i]['floor'],
            startDate: notifications['result'][i]['start_date'],
            endDate: notifications['result'][i]['end_date'],
            topic: notifications['result'][i]['topic'],
            occurredTimes: notifications['result'][i]['occurred_times'],
            to: notifications['result'][i]['to'],
            description: notifications['result'][i]['description'],
            recommendedActions: notifications['result'][i]['recommended_actions'],
            severity: notifications['result'][i]['severity'],
            notification_id: notifications['result'][i]['notification_id'],
            acknowledged: notifications['result'][i]['acknowledged'],
          })
        }

        context.commit('updateNotification', output)
        context.commit('updateTotalNumber', notifications['total_number_with_acknowledged'])
    }
    }
  },
  mutations: {
    updateNotification (state, payload) {
      Vue.set(state, 'notifications', payload)
    },
    updateTotalNumber (state, payload) {
      state.totalNotificationsCountIncludeAcknowledged = payload
    }
  }
}

export default notificationStore
